import { throttle } from "./utils.js";

export function handleTopnavLinks(config) {
  // Listen for click events on links within the top navbar
  document.querySelectorAll(".scroll-link").forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      // Get the target section's ID from the clicked link's href attribute
      const targetLink = this.getAttribute("href");
      const targetHash = targetLink?.split("#")[1];

      if (!targetHash) {
        if (targetLink) window.location.href = targetLink;
        return;
      }

      const targetElement = document.getElementById(targetHash);

      if (targetElement) {
        // Calculate the position of the target section
        const targetPosition = targetElement.offsetTop;

        // Disable animations on elements up to the target section
        document.querySelectorAll(".animate-on-scroll").forEach((el) => {
          if (el.offsetTop < targetPosition) {
            el.classList.add("disable-animation");
          }
        });

        // Scroll to the target section
        window.scrollTo({ top: targetPosition, behavior: "smooth" });
        const scrollDuration = calculateScrollDuration(targetPosition);

        disableScrollAnimation(scrollDuration, config);
        closeMobileNav();
      } else {
        // follow targetLink link
        if (targetLink) window.location.href = targetLink;
      }
    });
  });
}

function closeMobileNav() {
  const menuToggle = document.querySelector(".menu-toggle");
  menuToggle?.classList.remove("open");
  document.querySelector(".mobile-nav")?.classList.remove("open");
}

export function disableScrollAnimation(duration, config) {
  if (!config?.website?.navbar) return;

  config.website.navbar.autopilot = true;
  setTimeout(() => {
    config.website.navbar.autopilot = false;

    showNavbar();
  }, duration);
}

function calculateScrollDuration(targetPosition) {
  const baseDuration = 300;
  const distance = Math.abs(window.scrollY - targetPosition);
  return baseDuration + distance / 3;
}

export function triggerInitialCheck() {
  const navbar = document.querySelector(".header");
  if (!navbar) return;

  const darkPlaces = document.querySelectorAll(".dark-place");

  const isDarkPlaceVisible = Array.from(darkPlaces).some((section) => {
    const sectionRect = section.getBoundingClientRect();
    const navbarRect = navbar.getBoundingClientRect();

    return (
      sectionRect.bottom > navbarRect.top && sectionRect.top < navbarRect.bottom
    );
  });

  if (isDarkPlaceVisible) {
    navbar.classList.add("navbar-bright");
  } else {
    navbar.classList.remove("navbar-bright");
  }
}

export function navBarRecolorator() {
  const navbar = document.querySelector(".header");
  if (!navbar) return;

  const options = {
    root: null,
    threshold: 0.01,
    rootMargin: `0px 0px -98% 0px`,
  };

  const observer = new IntersectionObserver((entries) => {
    let navbarBright = false;
    entries.reverse().forEach((entry) => {
      if (entry.isIntersecting) {
        navbarBright = true;
      }
    });
    if (navbarBright) {
      navbar.classList.add("navbar-bright");
    } else {
      navbar.classList.remove("navbar-bright");
    }
  }, options);

  // Observe each .dark-place element
  document.querySelectorAll(".dark-place").forEach((section) => {
    observer.observe(section);
  });
}

export function showNavbar() {
  const navbar = document.querySelector(".header");
  if (!navbar) return;

  navbar.style.transform = "translateY(0)";

  function onTransitionEnd() {
    triggerInitialCheck();

    navbar.removeEventListener("transitionend", onTransitionEnd);
  }
  navbar.addEventListener("transitionend", onTransitionEnd);
}

export function hideNavbarOnScroll(config) {
  if (!config?.website?.navbar?.autoHideNavbarOnScroll) {
    return;
  }
  const navbar = document.querySelector(".header");
  if (!navbar) return;

  let prevScrollPos = window.scrollY;
  const handleScroll = () => {
    if (config.website.navbar.autopilot) {
      return;
    }
    let currentScrollPos = window.scrollY;
    if (prevScrollPos > currentScrollPos) {
      navbar.style.transform = "translateY(0)";
    } else {
      navbar.style.transform = "translateY(-100%)";
    }
    prevScrollPos = currentScrollPos;
  };

  // Use the general throttle function
  const throttledScrollHandler = throttle(handleScroll, 100);

  window.addEventListener("scroll", throttledScrollHandler);
}
